/*!
 * devextreme-angular-test
 * Version: 17.2.8
 * Build date: Mon Feb 05 2018
 *
 * Copyright (c) 2012 - 2018 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */


import {
    Component,
    NgModule,
    Host,
    SkipSelf,
    Input
} from '@angular/core';



import { NestedOptionHost } from '../../core/nested-option';
import { NestedOption } from '../../core/nested-option';



export class DxoImageComponent extends NestedOption {
    
    get height(): number|
        { rangeMaxPoint?: number, rangeMinPoint?: number } {
        return this._getOption('height');
    }
    set height(value: number|
        { rangeMaxPoint?: number, rangeMinPoint?: number }) {
        this._setOption('height', value);
    }

    
    get url(): string|
        { rangeMaxPoint?: string, rangeMinPoint?: string } {
        return this._getOption('url');
    }
    set url(value: string|
        { rangeMaxPoint?: string, rangeMinPoint?: string }) {
        this._setOption('url', value);
    }

    
    get width(): number|
        { rangeMaxPoint?: number, rangeMinPoint?: number } {
        return this._getOption('width');
    }
    set width(value: number|
        { rangeMaxPoint?: number, rangeMinPoint?: number }) {
        this._setOption('width', value);
    }

    
    get location(): string {
        return this._getOption('location');
    }
    set location(value: string) {
        this._setOption('location', value);
    }

    protected get _optionPath() {
        return 'image';
    }


    constructor(  parentOptionHost: NestedOptionHost,
             optionHost: NestedOptionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'dxo-image',
    template: '',
    styles: [''],
    providers: [NestedOptionHost]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: NestedOptionHost, decorators: [{ type: SkipSelf }, { type: Host }, ]},
{type: NestedOptionHost, decorators: [{ type: Host }, ]},
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'height': [{ type: Input },],
'url': [{ type: Input },],
'width': [{ type: Input },],
'location': [{ type: Input },],
};
}


export class DxoImageModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [
    DxoImageComponent
  ],
  exports: [
    DxoImageComponent
  ],
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
